import BaseService from "../../BaseService";

export default class VerordnungService extends BaseService {

  constructor() {
    super('verordnung');
  }

  async activate(id) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/${id}/activate`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async cancel(id, stornierungsdatum) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/${id}/cancel`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify({stornierungsdatum})
      })
    )
  }

  async calculatePerioden(calcObj) {
    return this.create(calcObj, '/calculatePerioden')
  }

  async listArt() {
    return this.list('listArt')
  }

  async listStatus() {
    return this.list('listStatus')
  }

  async listDauerPeriode() {
    return this.list('listDauerPeriode')
  }

  async listReferenzart() {
    return this.list('listReferenzart')
  }

  async listVerbrauchergruppe() {
    return this.list('listVerbrauchergruppe')
  }
}
